import React from 'react';
import { StepList } from '../deck/StepList';
import { StepSlide } from '../deck/StepSlide';
import { PayoutsMockup } from '../mockups/PayoutsMockup';
export function BankAccountSlide() {
  return <StepSlide step={8} title="Add the bank account for donations" visual={<PayoutsMockup data-id="element-202" data-mp="3vnv7qbgdv0fe" />} visualLabel="Linked accounts and payouts page with the gear icon, Linked accounts tab, and Add bank account button marked 1 to 3" data-id="element-201" data-mp="3rm0593mpuh01">
      <StepList items={[<>
            Click the <strong data-id="element-204" data-mp="9fv9i63939ws">gear</strong> icon (Settings) at the top right. Then find{' '}
            <strong data-id="element-205" data-mp="e73l98s1z7d4">Payouts</strong> ("Linked accounts and payouts").
          </>, <>
            Make sure you're on the <strong data-id="element-206" data-mp="j5erzan1x1r4">Linked accounts</strong> tab.
          </>, <>
            Click <strong data-id="element-207" data-mp="n931vzz5o9fj">"+ Add bank account"</strong>.
          </>, <>
            Type in the bank <strong data-id="element-208" data-mp="s6mpvrlno0ko">routing number</strong> and <strong data-id="element-209" data-mp="s7xqxjnpuu83">account number</strong>.
            Signing in to the bank instead also works.
          </>, <>Follow the prompts to save it.</>]} data-id="element-203" data-mp="4fppnc382rp9" />
    </StepSlide>;
}